module.exports = __webpack_public_path__ + "img/x-icon.d7cb55fe.svg";